import  { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { resolveAuthState } from "./authApi";
import { getRouteFromCode, getUserStatus, looksLikeJwt, getAccessToken } from "./authRouting";

export default function PublicOnlyRoute({ children }) {
  const [state, setState] = useState({
    loading: true,
    redirectTo: null,
  });

  useEffect(() => {
    let mounted = true;

    const run = async () => {
      const token = getAccessToken();

      if (!looksLikeJwt(token)) {
        if (mounted) {
          setState({ loading: false, redirectTo: null });
        }
        return;
      }

      const auth = await resolveAuthState();
      const userStatus = getUserStatus();

      if (!mounted) return;

      if (!auth.isAuthenticated) {
        setState({ loading: false, redirectTo: null });
        return;
      }

      if (auth.onboardingStatus === "COMPLETED") {
        setState({ loading: false, redirectTo: "/profile" });
        return;
      }

      if (typeof auth.onboardingStatus === "number") {
        const route = getRouteFromCode(auth.onboardingStatus, userStatus);
        setState({
          loading: false,
          redirectTo: route || "/account-type-select",
        });
        return;
      }

      setState({ loading: false, redirectTo: "/account-type-select" });
    };

    run();

    return () => {
      mounted = false;
    };
  }, []);

  if (state.loading) return null;

  if (state.redirectTo) {
    return <Navigate to={state.redirectTo} replace />;
  }

  return children;
}